// extracted by mini-css-extract-plugin
export default {"question":"rpkLGXmTHPh9gHRYFBu0","add":"A5YMo3x781OJ8AWiN0na"};